export interface Country {
  name: string;
  code: string;
  dialCode: string;
  flag: string;
  format?: string;
  maxLength?: number;
}

export type InputMode = 'email' | 'phone' | 'undetermined';
export type AllowedInputType = 'email' | 'phone' | 'both';

export const COUNTRIES: Country[] = [
  {
    name: 'Afganistán',
    code: 'AF',
    dialCode: '+93',
    flag: '🇦🇫',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Albania',
    code: 'AL',
    dialCode: '+355',
    flag: '🇦🇱',
    format: 'XXX XXX XXX',
    maxLength: 9,
  },
  {
    name: 'Alemania',
    code: 'DE',
    dialCode: '+49',
    flag: '🇩🇪',
    format: 'XXX XXXXXXX',
    maxLength: 10,
  },
  {
    name: 'Andorra',
    code: 'AD',
    dialCode: '+376',
    flag: '🇦🇩',
    format: 'XXX XXX',
    maxLength: 6,
  },
  {
    name: 'Angola',
    code: 'AO',
    dialCode: '+244',
    flag: '🇦🇴',
    format: 'XXX XXX XXX',
    maxLength: 9,
  },
  {
    name: 'Anguila',
    code: 'AI',
    dialCode: '+1',
    flag: '🇦🇮',
    format: 'XXX-XXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Antigua y Barbuda',
    code: 'AG',
    dialCode: '+1',
    flag: '🇦🇬',
    format: 'XXX-XXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Arabia Saudita',
    code: 'SA',
    dialCode: '+966',
    flag: '🇸🇦',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Argelia',
    code: 'DZ',
    dialCode: '+213',
    flag: '🇩🇿',
    format: 'XXX XX XX XX',
    maxLength: 9,
  },
  {
    name: 'Argentina',
    code: 'AR',
    dialCode: '+54',
    flag: '🇦🇷',
    format: 'XX XXXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Armenia',
    code: 'AM',
    dialCode: '+374',
    flag: '🇦🇲',
    format: 'XX XXX XXX',
    maxLength: 8,
  },
  {
    name: 'Aruba',
    code: 'AW',
    dialCode: '+297',
    flag: '🇦🇼',
    format: 'XXX XXXX',
    maxLength: 7,
  },
  {
    name: 'Australia',
    code: 'AU',
    dialCode: '+61',
    flag: '🇦🇺',
    format: 'XXX XXX XXX',
    maxLength: 9,
  },
  {
    name: 'Austria',
    code: 'AT',
    dialCode: '+43',
    flag: '🇦🇹',
    format: 'XXX XXXXXXX',
    maxLength: 10,
  },
  {
    name: 'Azerbaiyán',
    code: 'AZ',
    dialCode: '+994',
    flag: '🇦🇿',
    format: 'XX XXX XX XX',
    maxLength: 9,
  },
  {
    name: 'Bahamas',
    code: 'BS',
    dialCode: '+1',
    flag: '🇧🇸',
    format: 'XXX-XXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Bangladés',
    code: 'BD',
    dialCode: '+880',
    flag: '🇧🇩',
    format: 'XXXX-XXXXXX',
    maxLength: 10,
  },
  {
    name: 'Barbados',
    code: 'BB',
    dialCode: '+1',
    flag: '🇧🇧',
    format: 'XXX-XXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Baréin',
    code: 'BH',
    dialCode: '+973',
    flag: '🇧🇭',
    format: 'XXXX XXXX',
    maxLength: 8,
  },
  {
    name: 'Bélgica',
    code: 'BE',
    dialCode: '+32',
    flag: '🇧🇪',
    format: 'XXX XX XX XX',
    maxLength: 9,
  },
  {
    name: 'Belice',
    code: 'BZ',
    dialCode: '+501',
    flag: '🇧🇿',
    format: 'XXX-XXXX',
    maxLength: 7,
  },
  {
    name: 'Benín',
    code: 'BJ',
    dialCode: '+229',
    flag: '🇧🇯',
    format: 'XX XX XX XX',
    maxLength: 8,
  },
  {
    name: 'Bermudas',
    code: 'BM',
    dialCode: '+1',
    flag: '🇧🇲',
    format: 'XXX-XXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Bolivia',
    code: 'BO',
    dialCode: '+591',
    flag: '🇧🇴',
    format: 'X XXX XXXX',
    maxLength: 8,
  },
  {
    name: 'Bosnia y Herzegovina',
    code: 'BA',
    dialCode: '+387',
    flag: '🇧🇦',
    format: 'XX XXX XXX',
    maxLength: 8,
  },
  {
    name: 'Botsuana',
    code: 'BW',
    dialCode: '+267',
    flag: '🇧🇼',
    format: 'XX XXX XXX',
    maxLength: 8,
  },
  {
    name: 'Brasil',
    code: 'BR',
    dialCode: '+55',
    flag: '🇧🇷',
    format: 'XX XXXXX-XXXX',
    maxLength: 11,
  },
  {
    name: 'Brunéi',
    code: 'BN',
    dialCode: '+673',
    flag: '🇧🇳',
    format: 'XXX XXXX',
    maxLength: 7,
  },
  {
    name: 'Bulgaria',
    code: 'BG',
    dialCode: '+359',
    flag: '🇧🇬',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Burkina Faso',
    code: 'BF',
    dialCode: '+226',
    flag: '🇧🇫',
    format: 'XX XX XX XX',
    maxLength: 8,
  },
  {
    name: 'Burundi',
    code: 'BI',
    dialCode: '+257',
    flag: '🇧🇮',
    format: 'XX XX XX XX',
    maxLength: 8,
  },
  {
    name: 'Cabo Verde',
    code: 'CV',
    dialCode: '+238',
    flag: '🇨🇻',
    format: 'XXX XX XX',
    maxLength: 7,
  },
  {
    name: 'Camboya',
    code: 'KH',
    dialCode: '+855',
    flag: '🇰🇭',
    format: 'XX XXX XXX',
    maxLength: 8,
  },
  {
    name: 'Camerún',
    code: 'CM',
    dialCode: '+237',
    flag: '🇨🇲',
    format: 'X XX XX XX XX',
    maxLength: 9,
  },
  {
    name: 'Canadá',
    code: 'CA',
    dialCode: '+1',
    flag: '🇨🇦',
    format: 'XXX-XXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Chile',
    code: 'CL',
    dialCode: '+56',
    flag: '🇨🇱',
    format: 'X XXXX XXXX',
    maxLength: 9,
  },
  {
    name: 'China',
    code: 'CN',
    dialCode: '+86',
    flag: '🇨🇳',
    format: 'XXX XXXX XXXX',
    maxLength: 11,
  },
  {
    name: 'Chipre',
    code: 'CY',
    dialCode: '+357',
    flag: '🇨🇾',
    format: 'XX XXX XXX',
    maxLength: 8,
  },
  {
    name: 'Colombia',
    code: 'CO',
    dialCode: '+57',
    flag: '🇨🇴',
    format: 'XXX XXX XXXX',
    maxLength: 10,
  },
  {
    name: 'Corea del Norte',
    code: 'KP',
    dialCode: '+850',
    flag: '🇰🇵',
    format: 'XXX XXX XXXX',
    maxLength: 10,
  },
  {
    name: 'Corea del Sur',
    code: 'KR',
    dialCode: '+82',
    flag: '🇰🇷',
    format: 'XX XXXX XXXX',
    maxLength: 10,
  },
  {
    name: 'Costa Rica',
    code: 'CR',
    dialCode: '+506',
    flag: '🇨🇷',
    format: 'XXXX-XXXX',
    maxLength: 8,
  },
  {
    name: 'Croacia',
    code: 'HR',
    dialCode: '+385',
    flag: '🇭🇷',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Cuba',
    code: 'CU',
    dialCode: '+53',
    flag: '🇨🇺',
    format: 'X XXX XXXX',
    maxLength: 8,
  },
  {
    name: 'Dinamarca',
    code: 'DK',
    dialCode: '+45',
    flag: '🇩🇰',
    format: 'XX XX XX XX',
    maxLength: 8,
  },
  {
    name: 'Ecuador',
    code: 'EC',
    dialCode: '+593',
    flag: '🇪🇨',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Egipto',
    code: 'EG',
    dialCode: '+20',
    flag: '🇪🇬',
    format: 'XXX XXX XXXX',
    maxLength: 10,
  },
  {
    name: 'El Salvador',
    code: 'SV',
    dialCode: '+503',
    flag: '🇸🇻',
    format: 'XXXX-XXXX',
    maxLength: 8,
  },
  {
    name: 'Emiratos Árabes Unidos',
    code: 'AE',
    dialCode: '+971',
    flag: '🇦🇪',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'España',
    code: 'ES',
    dialCode: '+34',
    flag: '🇪🇸',
    format: 'XXX XX XX XX',
    maxLength: 9,
  },
  {
    name: 'Estados Unidos',
    code: 'US',
    dialCode: '+1',
    flag: '🇺🇸',
    format: 'XXX-XXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Estonia',
    code: 'EE',
    dialCode: '+372',
    flag: '🇪🇪',
    format: 'XXXX XXXX',
    maxLength: 8,
  },
  {
    name: 'Etiopía',
    code: 'ET',
    dialCode: '+251',
    flag: '🇪🇹',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Filipinas',
    code: 'PH',
    dialCode: '+63',
    flag: '🇵🇭',
    format: 'XXX XXX XXXX',
    maxLength: 10,
  },
  {
    name: 'Finlandia',
    code: 'FI',
    dialCode: '+358',
    flag: '🇫🇮',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Francia',
    code: 'FR',
    dialCode: '+33',
    flag: '🇫🇷',
    format: 'X XX XX XX XX',
    maxLength: 9,
  },
  {
    name: 'Ghana',
    code: 'GH',
    dialCode: '+233',
    flag: '🇬🇭',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Grecia',
    code: 'GR',
    dialCode: '+30',
    flag: '🇬🇷',
    format: 'XXX XXX XXXX',
    maxLength: 10,
  },
  {
    name: 'Guatemala',
    code: 'GT',
    dialCode: '+502',
    flag: '🇬🇹',
    format: 'XXXX-XXXX',
    maxLength: 8,
  },
  {
    name: 'Haití',
    code: 'HT',
    dialCode: '+509',
    flag: '🇭🇹',
    format: 'XX XX XXXX',
    maxLength: 8,
  },
  {
    name: 'Honduras',
    code: 'HN',
    dialCode: '+504',
    flag: '🇭🇳',
    format: 'XXXX-XXXX',
    maxLength: 8,
  },
  {
    name: 'Hungría',
    code: 'HU',
    dialCode: '+36',
    flag: '🇭🇺',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'India',
    code: 'IN',
    dialCode: '+91',
    flag: '🇮🇳',
    format: 'XXXXX XXXXX',
    maxLength: 10,
  },
  {
    name: 'Indonesia',
    code: 'ID',
    dialCode: '+62',
    flag: '🇮🇩',
    format: 'XXX-XXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Irán',
    code: 'IR',
    dialCode: '+98',
    flag: '🇮🇷',
    format: 'XXX XXX XXXX',
    maxLength: 10,
  },
  {
    name: 'Irlanda',
    code: 'IE',
    dialCode: '+353',
    flag: '🇮🇪',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Islandia',
    code: 'IS',
    dialCode: '+354',
    flag: '🇮🇸',
    format: 'XXX XXXX',
    maxLength: 7,
  },
  {
    name: 'Israel',
    code: 'IL',
    dialCode: '+972',
    flag: '🇮🇱',
    format: 'XX-XXX-XXXX',
    maxLength: 9,
  },
  {
    name: 'Italia',
    code: 'IT',
    dialCode: '+39',
    flag: '🇮🇹',
    format: 'XXX XXX XXXX',
    maxLength: 10,
  },
  {
    name: 'Jamaica',
    code: 'JM',
    dialCode: '+1',
    flag: '🇯🇲',
    format: 'XXX-XXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Japón',
    code: 'JP',
    dialCode: '+81',
    flag: '🇯🇵',
    format: 'XX-XXXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Jordania',
    code: 'JO',
    dialCode: '+962',
    flag: '🇯🇴',
    format: 'X XXXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Kenia',
    code: 'KE',
    dialCode: '+254',
    flag: '🇰🇪',
    format: 'XXX XXX XXX',
    maxLength: 9,
  },
  {
    name: 'Kuwait',
    code: 'KW',
    dialCode: '+965',
    flag: '🇰🇼',
    format: 'XXXX XXXX',
    maxLength: 8,
  },
  {
    name: 'Líbano',
    code: 'LB',
    dialCode: '+961',
    flag: '🇱🇧',
    format: 'XX XXX XXX',
    maxLength: 8,
  },
  {
    name: 'Luxemburgo',
    code: 'LU',
    dialCode: '+352',
    flag: '🇱🇺',
    format: 'XXX XXX XXX',
    maxLength: 9,
  },
  {
    name: 'Malasia',
    code: 'MY',
    dialCode: '+60',
    flag: '🇲🇾',
    format: 'XX-XXX-XXXX',
    maxLength: 9,
  },
  {
    name: 'Maldivas',
    code: 'MV',
    dialCode: '+960',
    flag: '🇲🇻',
    format: 'XXX-XXXX',
    maxLength: 7,
  },
  {
    name: 'Malta',
    code: 'MT',
    dialCode: '+356',
    flag: '🇲🇹',
    format: 'XXXX XXXX',
    maxLength: 8,
  },
  {
    name: 'Marruecos',
    code: 'MA',
    dialCode: '+212',
    flag: '🇲🇦',
    format: 'XXX-XXXXXX',
    maxLength: 9,
  },
  {
    name: 'México',
    code: 'MX',
    dialCode: '+52',
    flag: '🇲🇽',
    format: 'XX XXXX XXXX',
    maxLength: 10,
  },
  {
    name: 'Mónaco',
    code: 'MC',
    dialCode: '+377',
    flag: '🇲🇨',
    format: 'XX XX XX XX',
    maxLength: 8,
  },
  {
    name: 'Nepal',
    code: 'NP',
    dialCode: '+977',
    flag: '🇳🇵',
    format: 'XXX-XXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Nicaragua',
    code: 'NI',
    dialCode: '+505',
    flag: '🇳🇮',
    format: 'XXXX-XXXX',
    maxLength: 8,
  },
  {
    name: 'Nigeria',
    code: 'NG',
    dialCode: '+234',
    flag: '🇳🇬',
    format: 'XXX XXX XXXX',
    maxLength: 10,
  },
  {
    name: 'Noruega',
    code: 'NO',
    dialCode: '+47',
    flag: '🇳🇴',
    format: 'XXX XX XXX',
    maxLength: 8,
  },
  {
    name: 'Nueva Zelanda',
    code: 'NZ',
    dialCode: '+64',
    flag: '🇳🇿',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Países Bajos',
    code: 'NL',
    dialCode: '+31',
    flag: '🇳🇱',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Pakistán',
    code: 'PK',
    dialCode: '+92',
    flag: '🇵🇰',
    format: 'XXX XXX XXXX',
    maxLength: 10,
  },
  {
    name: 'Panamá',
    code: 'PA',
    dialCode: '+507',
    flag: '🇵🇦',
    format: 'XXXX-XXXX',
    maxLength: 8,
  },
  {
    name: 'Paraguay',
    code: 'PY',
    dialCode: '+595',
    flag: '🇵🇾',
    format: 'XXX XXX XXX',
    maxLength: 9,
  },
  {
    name: 'Perú',
    code: 'PE',
    dialCode: '+51',
    flag: '🇵🇪',
    format: 'XXX XXX XXX',
    maxLength: 9,
  },
  {
    name: 'Polonia',
    code: 'PL',
    dialCode: '+48',
    flag: '🇵🇱',
    format: 'XXX XXX XXX',
    maxLength: 9,
  },
  {
    name: 'Portugal',
    code: 'PT',
    dialCode: '+351',
    flag: '🇵🇹',
    format: 'XXX XXX XXX',
    maxLength: 9,
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
    dialCode: '+1',
    flag: '🇵🇷',
    format: 'XXX-XXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Reino Unido',
    code: 'GB',
    dialCode: '+44',
    flag: '🇬🇧',
    format: 'XXXX XXX XXXX',
    maxLength: 10,
  },
  {
    name: 'República Checa',
    code: 'CZ',
    dialCode: '+420',
    flag: '🇨🇿',
    format: 'XXX XXX XXX',
    maxLength: 9,
  },
  {
    name: 'República Dominicana',
    code: 'DO',
    dialCode: '+1',
    flag: '🇩🇴',
    format: 'XXX-XXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Rumania',
    code: 'RO',
    dialCode: '+40',
    flag: '🇷🇴',
    format: 'XXX XXX XXX',
    maxLength: 9,
  },
  {
    name: 'Rusia',
    code: 'RU',
    dialCode: '+7',
    flag: '🇷🇺',
    format: 'XXX XXX-XX-XX',
    maxLength: 10,
  },
  {
    name: 'Senegal',
    code: 'SN',
    dialCode: '+221',
    flag: '🇸🇳',
    format: 'XX XXX XX XX',
    maxLength: 9,
  },
  {
    name: 'Serbia',
    code: 'RS',
    dialCode: '+381',
    flag: '🇷🇸',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Singapur',
    code: 'SG',
    dialCode: '+65',
    flag: '🇸🇬',
    format: 'XXXX XXXX',
    maxLength: 8,
  },
  {
    name: 'Sudáfrica',
    code: 'ZA',
    dialCode: '+27',
    flag: '🇿🇦',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Suecia',
    code: 'SE',
    dialCode: '+46',
    flag: '🇸🇪',
    format: 'XX-XXX XX XX',
    maxLength: 9,
  },
  {
    name: 'Suiza',
    code: 'CH',
    dialCode: '+41',
    flag: '🇨🇭',
    format: 'XX XXX XX XX',
    maxLength: 9,
  },
  {
    name: 'Tailandia',
    code: 'TH',
    dialCode: '+66',
    flag: '🇹🇭',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
  {
    name: 'Taiwán',
    code: 'TW',
    dialCode: '+886',
    flag: '🇹🇼',
    format: 'XXXX XXX XXX',
    maxLength: 10,
  },
  {
    name: 'Túnez',
    code: 'TN',
    dialCode: '+216',
    flag: '🇹🇳',
    format: 'XX XXX XXX',
    maxLength: 8,
  },
  {
    name: 'Turquía',
    code: 'TR',
    dialCode: '+90',
    flag: '🇹🇷',
    format: 'XXX XXX XXXX',
    maxLength: 10,
  },
  {
    name: 'Ucrania',
    code: 'UA',
    dialCode: '+380',
    flag: '🇺🇦',
    format: 'XX XXX XX XX',
    maxLength: 9,
  },
  {
    name: 'Uruguay',
    code: 'UY',
    dialCode: '+598',
    flag: '🇺🇾',
    format: 'XX XXX XXX',
    maxLength: 8,
  },
  {
    name: 'Venezuela',
    code: 'VE',
    dialCode: '+58',
    flag: '🇻🇪',
    format: 'XXX-XXX-XXXX',
    maxLength: 10,
  },
  {
    name: 'Vietnam',
    code: 'VN',
    dialCode: '+84',
    flag: '🇻🇳',
    format: 'XXX XXX XXXX',
    maxLength: 10,
  },
  {
    name: 'Zimbabue',
    code: 'ZW',
    dialCode: '+263',
    flag: '🇿🇼',
    format: 'XX XXX XXXX',
    maxLength: 9,
  },
];
